
import './styles/quasar.scss'
import lang from 'quasar/lang/es.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css'


// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
  },
  lang: lang
}